import React from "react";
import { useTranslation } from "react-i18next";
import {
  LineChart,
  Legend,
  CartesianGrid,
  Tooltip,
  Line,
  XAxis,
  YAxis,
} from "recharts";

import {
  OrgHealthChartData,
  OrgHealthChartSettingData,
} from "../../../models/OrgHealthChartData";

import "./styles.scss";

export interface IOrgHealthLineChartLineProps {
  width: number;
  height: number;
  chartData: OrgHealthChartData;
}

export const OrgHealthLineChart: React.FunctionComponent<
  IOrgHealthLineChartLineProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`dashboardPage.orgHealthLineChart.${key}`);

  const { width, height, chartData } = props;

  const processedData = chartData.data.map((item) => {
    const processedItem = { ...item };

    Object.keys(processedItem).forEach((key) => {
      if (key !== "date" && typeof processedItem[key] === "string") {
        processedItem[key] = parseFloat(processedItem[key] as string);
      }
    });

    return processedItem;
  });

  if (!chartData) {
    return null;
  }

  return (
    <LineChart width={width} height={height} data={processedData}>
      <Legend
        iconType="plainline"
        wrapperStyle={{ fontSize: "12px", fontWeight: 700 }}
      />
      <CartesianGrid strokeDasharray="3 2" />
      <XAxis
        dataKey="date"
        tick={{ fontSize: 13 }}
        style={{ fontFamily: "Inter" }}
      />
      <YAxis
        tick={{ fontSize: 13 }}
        tickCount={6}
        style={{ fontFamily: "Inter" }}
        tickFormatter={(value: number) =>
          new Intl.NumberFormat("ja").format(value)
        }
      />
      <Tooltip
        formatter={(value) =>
          new Intl.NumberFormat("ja").format(value as number)
        }
        labelFormatter={(value) => {
          return `${t("date") || "日付"}: ${value}`;
        }}
        itemSorter={(item) => {
          const order = { A: 1, B: 2, C: 3, D: 4 };
          return order[item.dataKey as keyof typeof order] || 999;
        }}
      />
      {chartData.dataSourceSettings.map(
        (item: OrgHealthChartSettingData, index: number) => (
          <React.Fragment key={index}>
            <Line
              type="linear"
              name={item.label}
              dataKey={item.fieldName}
              stroke={item.color}
              strokeWidth={3}
              dot={false}
              strokeDasharray={item.style === "dashed" ? "8 4" : undefined}
            />
          </React.Fragment>
        )
      )}
    </LineChart>
  );
};

export default OrgHealthLineChart;
